<upp-application menu="show">
    <upp-application-menu>
    </upp-application-menu>
    <upp-application-main>
        <upp-application-page>
            <upp-panel size="large">
                <upp-panel-header>
                    <upp-header [menu]="'show'" color="primary" lines="warning">
                        <upp-header-title>
                            HOLA MUNDO
                        </upp-header-title>
                        <upp-header-button>
                            BUTTON1
                        </upp-header-button>
                        <upp-header-button uppDataid="test-button-drop" (click)="OnDropdown()">
                            <ion-icon name="ellipsis-vertical"></ion-icon>
                        </upp-header-button>
                        <upp-header-button size="small" uppDataid="test-button-close">
                            <ion-icon name="close-outline"></ion-icon>
                        </upp-header-button>
                    </upp-header>
                
                    <upp-dropdown [expand]="dropdownOpen" (OnClosed)="OnDropdown()">
                        <upp-dropdown-title>
                            TITULO
                        </upp-dropdown-title>
                        <upp-dropdown-content>
                            <ion-item>
                                <ion-label>OPCION 1.1</ion-label>
                            </ion-item>
                            <ion-item>
                                <ion-label>OPCION 1.2</ion-label>
                            </ion-item>
                            <ion-item>
                                <ion-label>OPCION 1.3</ion-label>
                            </ion-item>
                        </upp-dropdown-content>
                        <upp-dropdown-separate></upp-dropdown-separate>
                        <upp-dropdown-content>
                            <ion-radio-group uppDataid="test-radio-gridmode" [value]="GridMode" (ionChange)="OnGridModeChange($event)">
                                <ion-item lines="none">
                                    <ion-label>Ver en modo grid</ion-label>
                                    <ion-radio uppDataid="test-radio-grid-option" value="GRID" slot="end"></ion-radio>
                                </ion-item>
                                <ion-item lines="none">
                                    <ion-label>Ver en modo lista</ion-label>
                                    <ion-radio uppDataid="test-radio-list-option" value="LIST" slot="end"></ion-radio>
                                </ion-item>
                            </ion-radio-group>
                        </upp-dropdown-content>
                    </upp-dropdown>
                </upp-panel-header>
                <upp-panel-content>
                    <ion-note class="upp-test-dev-links" color="primary">
                        <a [routerLink]="['/demo', 'konva']">upp-konva</a>
                        <span aria-hidden="true"> · </span>
                        <a [routerLink]="['/demo']">Widget demos</a>
                    </ion-note>
                    <upp-grid name="TEST_GRID">
                        <upp-grid-item *ngFor="let _text of _scrolltest">
                            <upp-thumb [title]="_text" [detail]="_text"></upp-thumb>
                        </upp-grid-item>
                    </upp-grid>
                </upp-panel-content>
                <upp-panel-footer>
                    ADIOS MUNDO
                </upp-panel-footer>
            </upp-panel>                
            <upp-panel size="small" lines="hide">
                <upp-panel-header>
                    <upp-header [menu]="'show'" color="light" lines="warning">
                        <upp-header-title>
                            SECUNDARIO
                        </upp-header-title>
                        <upp-header-button size="small" uppDataid="test-button-close">
                            <ion-icon name="close-outline"></ion-icon>
                        </upp-header-button>
                    </upp-header>
                </upp-panel-header>
                <upp-panel-content>
                    <ion-list [formGroup]="form">
                        <ion-item>
                            <upp-input formControlName="example" type="text" placeholder="placeholder de input" title="title de input" [errornfo]="{ required: 'El campo es obligatorio'} "></upp-input> 
                        </ion-item>
                        <ion-item>
                            <upp-input
                                [(ngModel)]="custom"
                                [ngModelOptions]="{ standalone: true }"
                                type="password"
                                placeholder="placeholder de input"
                                title="title de input"
                                [errornfo]="{ required: 'El campo es obligatorio'} "
                            ></upp-input>
                        </ion-item>
                        <ion-item>
                            <upp-input  formControlName="example" type="text" placeholder="placeholder de input" title="title de input" [errornfo]="{ required: 'El campo es obligatorio'} "></upp-input> 
                        </ion-item>
                    </ion-list>    
                    CONTENIDO 2<br/>
                    {{form.get('example')?.value || ''}}<br/>
                    {{custom || ''}}<br/>
                </upp-panel-content>
            </upp-panel>                                    
        </upp-application-page>
    </upp-application-main>
</upp-application>

<!--
<upp-application menu="show">
    <upp-application-menu>
    </upp-application-menu>
    <upp-application-main>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <upp-panel size="large">
                        <upp-panel-header>
                            <upp-header-item [menu]="'show'">
                                <upp-header-title>
                                    HOLA MUNDO
                                </upp-header-title>
                                <upp-header-button>
                                    BUTTON1
                                </upp-header-button>
                                <upp-header-button uppDataid="test-button-close">
                                    <ion-icon name="close-outline"></ion-icon>
                                </upp-header-button>
                            </upp-header-item>
                        </upp-panel-header>
                        <upp-panel-content>
                            CONTENIDO
                        </upp-panel-content>
                        <upp-panel-footer>
                            ADIOS MUNDO
                        </upp-panel-footer>
                    </upp-panel>                
                </ion-col>                
                <ion-col>
                    <upp-panel size="small">

                    </upp-panel>                                
                </ion-col>                
            </ion-row>
        </ion-grid>
    </upp-application-main>
</upp-application>
-->

<!--
<upp-application>
    <upp-panel>
        <upp-panel-header>
            <upp-header-item [menu]="'show'">
                <upp-header-title>
                    HOLA MUNDO
                </upp-header-title>
                <upp-header-button>
                    BUTTON1
                </upp-header-button>
                <upp-header-button uppDataid="test-button-close">
                    <ion-icon name="close-outline"></ion-icon>
                </upp-header-button>
            </upp-header-item>
        </upp-panel-header>
        <upp-panel-content>
            CONTENIDO
        </upp-panel-content>
        <upp-panel-footer>
            ADIOS MUNDO
        </upp-panel-footer>
    </upp-panel>    
</upp-application>
-->

<!--
<ion-menu #mnmenu id="mnmenu" side="start" menuId="main" contentId="content-main-menu">
</ion-menu>
<ion-nav id="content-main-menu">
    <upp-panel>
        <upp-panel-header>
            <upp-header-item [menu]="'show'">
                <upp-header-title>
                    HOLA MUNDO
                </upp-header-title>
                <upp-header-button>
                    BUTTON1
                </upp-header-button>
                <upp-header-button uppDataid="test-button-close">
                    <ion-icon name="close-outline"></ion-icon>
                </upp-header-button>
            </upp-header-item>
        </upp-panel-header>
        <upp-panel-content>
            CONTENIDO
        </upp-panel-content>
        <upp-panel-footer>
            ADIOS MUNDO
        </upp-panel-footer>
    </upp-panel>    
</ion-nav>
-->

<!--
<ion-header>
    <ion-toolbar>
        <ion-title>
            upp-base tester
        </ion-title>
        <ion-buttons slot="end">
            <ion-select [value]="currentLanguage" (ionChange)="changeLanguage($event.detail.value)" interface="action-sheet" aria-label="Language Selection">
                <ion-select-option *ngFor="let lang of availableLanguages" [value]="lang.lang">
                     {{ lang.flag }}
                </ion-select-option>
            </ion-select>
        </ion-buttons>        
    </ion-toolbar>
</ion-header>
  
<ion-content class="ion-padding">
    <div class="center-container">
        <div *ngIf="currentCampaign == null">
            <ion-button expand="block" shape="round" (click)="startCampaign()">
                {{tr('@test_start_campaign')}}
            </ion-button>
        </div>

        <div *ngIf="currentCampaign != null">
            <h2>{{tr('@test_campaign_name', [ currentCampaign ] )}}</h2>
            <ion-button expand="block" shape="round" color="danger" (click)="stopCampaign()">
                {{tr('@test_stop_campaign')}}
            </ion-button>
        </div>
      
        <ion-button expand="block" shape="round" (click)="logStressTest()">
            {{tr('@test_loggger_stress')}}
        </ion-button>

    </div>
</ion-content>
-->

